import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette }) => ({
  button: {
    color: palette.common.black,
  },
  "button--active": {
    "& svg": {
      color: palette.primary.main,
    },
    color: palette.primary.main,
  },
}));
